import * as ActionTypes from 'src/constants/ActionTypes';
import { IStateOrder } from 'src/entity/StateEntity';
import { IOrderInfo } from 'src/entity/OrderEntity';
import { reloadDrugStores } from './drugStoreCreator';
import { reloadLocations } from './locationCreator';
import { clearUserInfo } from './userCreator';
import { initWebSocketState } from './webSocketCreator';
import { reloadMallBrand } from './mallBrandCreator';
import { reloadMallCategory } from './mallCategoryCreator';
import { reloadMallPharmacy } from './mallPharmacyCreator';
import { reloadSpuTCM } from './spuTCMCreator';
import { reloadSpuCPM } from './spuCPMCreator';
import { clearLogin } from './authCreator';
import { reloadDepartments } from './departmentCreator';

export function selectOrder(orderInfo: IOrderInfo): IStateOrder {
  return {
    type: ActionTypes.ORDER_INFO_SELECT,
    orderInfo,
  };
}

export function clearOrder(): IStateOrder {
  return {
    type: ActionTypes.ORDER_INFO_INVALIDATE,
    orderInfo: undefined,
  };
}

/**
 * 清空缓存数据
 *
 * @export
 * @param {*} dispatch
 */
export function clearSessionData(dispatch: any) {
  dispatch(reloadDrugStores());
  dispatch(reloadLocations());
  dispatch(reloadMallBrand());
  dispatch(reloadMallCategory());
  dispatch(reloadMallPharmacy());
  dispatch(reloadSpuTCM());
  dispatch(reloadSpuCPM());
  dispatch(clearUserInfo());
  dispatch(initWebSocketState());
  dispatch(clearLogin());
  dispatch(reloadDepartments())
}



// WEBPACK FOOTER //
// ./src/redux/actions/index.ts